import { Chip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PassType } from '../../api';

// Palette paths, resolved by `sx`.
const PASS_TYPE_COLORS: Record<PassType, string> = {
  [PassType.PUNCH_BASED]: 'text.primary',
  [PassType.UNLIMITED_MONTHLY]: 'primary.main',
  [PassType.FIXED_SCHEDULE_MONTHLY]: 'secondary.dark',
};

type PassTypeChipProps = {
  passType?: PassType;
};

export const PassTypeChip = ({ passType }: PassTypeChipProps) => {
  const { t } = useTranslation();

  if (!passType) return null;

  return (
    <Chip
      size="small"
      label={t(`passes.pass_type.${passType}`)}
      sx={{
        backgroundColor: PASS_TYPE_COLORS[passType],
        color: 'common.white',
        borderRadius: '4px',
        fontWeight: 700,
        height: 20,
        '& .MuiChip-label': { px: 0.75, fontSize: '0.7rem' },
      }}
    />
  );
};
